import { render, staticRenderFns } from "./RadioFieldtype.vue?vue&type=template&id=4d65d352&"
import script from "./RadioFieldtype.vue?vue&type=script&lang=js&"
export * from "./RadioFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports